/**
 * WideGroupedModal — the wide/grouped-form mechanic (§27). A wide modal whose
 * body is a series of `.subhead`-divided sections, each a `.mform.three`
 * (3-column) grid of numeric-heavy fields. Backs BHA/Bit run, Mud lab panel,
 * and HSE daily — the widest records, some with a nested child grid (BHA
 * components).
 *
 * Like HeaderChildModal, this is a thin composition over the shared <Modal>
 * shell: the caller passes `sections` (each is a <FormSection> already, or any
 * node) and optional footer. Only the section arrangement + wide default width
 * differ from the other modal shape — same shell, same footer, one code path.
 */
import type { ReactNode } from "react";
import { Modal } from "./Modal";

export interface WideGroupedModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  context?: string;
  /**
   * The grouped sections — typically <FormSection three> blocks, optionally
   * ending in a nested child grid section (e.g. BHA components).
   */
  children: ReactNode;
  footerNote?: ReactNode;
  footer?: ReactNode;
  /** Wide by default (§27 BHA modal is ~940px). */
  width?: number;
}

export function WideGroupedModal({
  open,
  onClose,
  title,
  context,
  children,
  footerNote,
  footer,
  width = 940,
}: WideGroupedModalProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      context={context}
      width={width}
      footerNote={footerNote}
      footer={footer}
    >
      {children}
    </Modal>
  );
}
